<template>
  <!-- Message button which can be found on the profile. The role of this button
is to open a direct message channel between viewer & profile. If a conversation
has already been started, then the Messenger is load. If not, a new message 
sender is opened instead, which when utilized, will switch to Messenger. -->
  <div @click="openMessenger" class="sendMessage">Message</div>
</template>

<script>
/**
 * Flow concept:
 * 1. Click and open modal to send message to single person
 * but also has button to go to core Messenger
 * Could also open in the corner (and perhaps usually might)
 *
 * 2. Upon sending a message, the actual Messenger is opened
 * 3. Messenger has view where you see other people's list
 * on the side, or you have focused view with just one person
 * or the people are shrinked into profile images
 *
 * 4. Message is sent and pushed through socket to a connected
 * participant
 *
 * 5. Shared data object created between two people, which
 * contains sessions together (id of sessions together),
 * and message is pushed to messages between people
 *
 *
 * LOAD WHETHER FIRST TIME OR NOT
 * E.G. check common stuff
 */
export default {
  name: "MessageButton",
  methods: {
    openMessenger() {
      this.$emit("openMessenger");
    },
  },
};
</script>

<style scoped>
.TEMP {
  position: absolute;
  z-index: 9999999999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  overflow: auto;
}
</style>